import React from "react";
import About from "../../components/About/About";

const AboutPage = () => {
  return (
    <div className="pb-5" style={{ paddingTop: "80px", minHeight: "100vh" }}>
      <About />
    </div>
  );
};

export default AboutPage;
